<template>
  <div>
    <CrmMappingManager />
  </div>
</template>

<script>
import CrmMappingManager from '@features/example/components/CrmMappingManager.vue';

export default {
  name: 'CrmMappingView',
  components: {
    CrmMappingManager,
  },
};
</script> 
 